export default "__VITE_ASSET__SqsMu9Rl__"